import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import Select from 'react-select';
import {
  getDomainProfile,
  getTimezoneList,
  updateDomainProfile,
} from '../../redux/MainAction';
import { Card, CardContent, Typography } from '@mui/material';
import { toast } from 'react-toastify';

const DomainTimeZone = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const timezones = useSelector((state) => state?.Webtracker?.timezoneList);
  const domainDetails = useSelector(
    (state) => state?.Webtracker?.domainDetails
  );

  const [profileData, setProfileData] = useState({
    workspaceName: '',
    // firstName: '',
    // lastName: '',
    // mobile: '',
  });

  useEffect(() => {
    if (domainDetails) {
      setProfileData({
        workspaceName: domainDetails?.userDetail?.workspaceName || '',
        // firstName: domainDetails?.firstName || '',
        // lastName: domainDetails?.lastName || '',
        // mobile: domainDetails?.userDetail?.mobile || '',
      });
    }
  }, [domainDetails]);

  const openModal = () => {
    setIsModalOpen(true);
    dispatch(getTimezoneList());
    dispatch(getDomainProfile());
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsEditMode(false);
  };

  const handleUpdateTimezone = async (timezoneId) => {
    await dispatch(updateDomainProfile({ timezoneId }, 'Timezone'));
    dispatch(getDomainProfile());
    closeModal();
  };

  const handleUpdateProfile = async (data) => {
    // if (!+profileData?.mobile) {
    //   toast.error('Mobile can only have digits', {
    //     position: 'top-right',
    //   });
    //   return false;
    // }

    // if (profileData?.mobile?.length < 10) {
    //   toast.error('Moile cannot be less than 10 digits', {
    //     position: 'top-right',
    //   });
    //   return false;
    // }

    if (!profileData?.workspaceName) {
      toast.error('Workspace name can not be empty', {
        position: 'top-right',
      });
      return false;
    }

    await dispatch(updateDomainProfile(data));
    dispatch(getDomainProfile());
    closeModal();
  };

  const customModalStyles = {
    content: {
      top: '0',
      right: '0',
      left: 'auto',
      bottom: '0',
      width: '400px',
      height: '100%',
      padding: '20px',
      backgroundColor: '#fff',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
      zIndex: 999,
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
    },
  };

  const onChangeData = (e) => {
    const { name, value } = e.target;
    setProfileData({ ...profileData, [name]: value });
  };

  return (
    <>
      <li className="list-inline-item dropdown notification-list hidden-xs-down">
        <Link to="#" onClick={openModal}>
          <i className="mdi mdi-settings noti-icon"></i>
        </Link>
      </li>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Settings"
      >
        <h2 className="d-flex align-items-center justify-content-between">
          Profile / Settings{' '}
          <button className="btn btn-secondary" onClick={closeModal}>
            Close
          </button>
        </h2>

        <Card className="mt-4">
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Update Profile
            </Typography>

            <div className="mt-4">
              <div className="mb-2">
                <label for="username1" className="font-14 text-muted ">
                  Workspace Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Set workspace name"
                  className="form-control"
                  name="workspaceName"
                  value={profileData?.workspaceName}
                  onChange={onChangeData}
                  id="workspaceName"
                />
              </div>

              {/* <div className="mb-2">
                <label for="domainFirstName" className="font-14 text-muted ">
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter First Name"
                  className="form-control"
                  name="firstName"
                  value={profileData?.firstName}
                  onChange={onChangeData}
                  id="domainFirstName"
                />
              </div>

              <div className="mb-2">
                <label for="domainLastName" className="font-14 text-muted ">
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Last Name"
                  className="form-control"
                  name="lastName"
                  value={profileData?.lastName}
                  onChange={onChangeData}
                  id="domainLastName"
                />
              </div>

              <div className="mb-2">
                <label for="domainMobile" className="font-14 text-muted ">
                  Contact No <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  maxLength={10}
                  placeholder="Enter Contact No"
                  className="form-control"
                  name="mobile"
                  value={profileData?.mobile}
                  onChange={onChangeData}
                  id="domainMobile"
                />
              </div> */}
            </div>

            <button
              className="btn btn-primary mt-4"
              onClick={() => handleUpdateProfile(profileData)}
            >
              Save
            </button>
          </CardContent>
        </Card>

        <Card className="mt-4">
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Timezone
            </Typography>
            <div className="mt-2">
              <strong>Selected Timezone:</strong>{' '}
              {domainDetails?.userDetail?.timezoneRecord?.display ||
                'Not set yet'}
            </div>

            {isEditMode ? (
              <div className="mt-4">
                <Select
                  options={timezones?.rows.map((tz) => ({
                    value: tz.id,
                    label: tz.display,
                  }))}
                  onChange={(e) => handleUpdateTimezone(e.value)}
                  placeholder="Select new timezone"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 1000 }),
                  }}
                />
                <button
                  className="btn btn-secondary mt-4"
                  onClick={() => setIsEditMode(false)}
                >
                  Cancel
                </button>
              </div>
            ) : (
              <button
                className="btn btn-primary mt-4"
                onClick={() => setIsEditMode(true)}
              >
                Update Timezone
              </button>
            )}
          </CardContent>
        </Card>
      </Modal>
    </>
  );
};

export default DomainTimeZone;
